// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts'
import { DirectXMLMessage } from './DirectXMLMessage.js'
export let DirectCreateMessage = function ()
{
    DirectXMLMessage.call(this)
    this.Code = DirectMessageCode.CODE_XML_CREATE
    this.DialogId = 0
    this.OrderId = ''
    this.Symbol = ''
    this.OperationType = 0
    this.OrderType = 0
    this.Amount = 0
    this.Price = 0
    this.OpenOrderId = null
    this.BoundToOrderId = null
    this.AccountID = null
    this.BstrMarket = null
    // yura - NewPrice(для модификации Limit ордеров)
    this.NewPrice = 0
    this.ExpDate = null
}

DirectCreateMessage.prototype = Object.create(DirectXMLMessage.prototype)